module.exports = __webpack_public_path__ + "img/29-Breakouts.e1a56849.png";